
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/idziemy-dalej",
      function () {
        return require("private-next-pages/idziemy-dalej.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/idziemy-dalej"])
      });
    }
  